jQuery(document).ready(function($) {
    // Handle size counter buttons
    $(document).on('click', '.my-products-popup__size-button', function(e) {
        e.preventDefault();
        
        const $button = $(this);
        const $sizeBlock = $button.closest('.my-products-popup__size');
        const $quantity = $sizeBlock.find('.my-products-popup__size-quantity');
        const action = $button.data('action');
        let currentQuantity = parseInt($quantity.text()) || 0;
        
        if (action === 'increase') {
            currentQuantity++;
        } else if (action === 'decrease' && currentQuantity > 0) {
            currentQuantity--;
        }
        
        // Update quantity display
        $quantity.text(currentQuantity);
        
        // Update hidden number input for basket.js validation
        const $hiddenInput = $sizeBlock.find('.my-products-popup__size-input');
        $hiddenInput.val(currentQuantity);
        
        // Update active state
        if (currentQuantity > 0) {
            $sizeBlock.addClass('my-products-popup__size--active');
        } else {
            $sizeBlock.removeClass('my-products-popup__size--active');
        }
        
        // Update hidden form fields for single-size and qty
        const $form = $sizeBlock.closest('form[name="selected_product_options"]');
        const sizeId = $sizeBlock.data('size-id');
        const $singleSizeInput = $form.find('#my-products-popup__single-size');
        const $qtyInput = $form.find('#my-products-popup__qty');
        
        // Find the size with the highest quantity (or first with quantity > 0)
        let selectedSizeId = 0;
        let selectedQty = 0;
        
        $form.find('.my-products-popup__size').each(function() {
            const $thisSize = $(this);
            const qty = parseInt($thisSize.find('.my-products-popup__size-quantity').text()) || 0;
            if (qty > 0 && selectedSizeId === 0) {
                selectedSizeId = $thisSize.data('size-id');
                selectedQty = qty;
            }
        });
        
        $singleSizeInput.val(selectedSizeId);
        $qtyInput.val(selectedQty);
        
        // Update price display based on total quantity
        updatePriceDisplay($form);
    });
    
    // Function to update price display
    function updatePriceDisplay($form) {
        const $priceElement = $form.find('.my-products-popup__button-block-price');
        const basePrice = parseFloat($priceElement.data('base-price')) || 0;
        const currencySymbol = $priceElement.data('currency-symbol') || '£';
        
        // Calculate total quantity
        let totalQuantity = 0;
        $form.find('.my-products-popup__size-quantity').each(function() {
            const qty = parseInt($(this).text()) || 0;
            totalQuantity += qty;
        });
        
        // Calculate total price
        const totalPrice = basePrice * totalQuantity;
        
        // Format and display price
        if (totalQuantity > 0) {
            const formattedPrice = currencySymbol + totalPrice.toFixed(2);
            $priceElement.text(formattedPrice);
        } else {
            // Show base price when no quantity selected
            const formattedPrice = currencySymbol + basePrice.toFixed(2);
            $priceElement.text(formattedPrice);
        }
    }

    // Handle colour selection
    $(document).on('click', '.my-products-popup__colour', function(e) {
        e.preventDefault();
        
        const $colour = $(this);
        const $form = $colour.closest('form[name="selected_product_options"]');
        const colourId = $colour.data('colour-id');
        
        if (!colourId) return;
        
        // Update selected state
        $form.find('.my-products-popup__colour').removeClass('my-products-popup__colour--selected');
        $colour.addClass('my-products-popup__colour--selected');
        
        // Update hidden input
        $form.find('#my-products-popup__chosen-colour').val(colourId);
        
        // Note: Changing colour will use the new colour but keep the preset customisation
        // Sizes are already loaded for all available colours, so no need to reload
        // If sizes need to change based on colour, that would require a page reload or AJAX call
    });

    // Handle View/Hide Customisation toggle
    $(document).on('click', '.my-products-popup__title-block-button', function(e) {
        e.preventDefault();
        
        const $button = $(this);
        const $popup = $button.closest('.my-products-popup');
        const $body = $popup.find('.my-products-popup__body');
        const $customisationBlock = $popup.find('.my-products-popup__customisation-block');
        
        // Check current state
        const isViewingCustomisation = $customisationBlock.hasClass('my-products-popup__customisation-block--visible');
        
        if (isViewingCustomisation) {
            // Hide customisation, show body
            $customisationBlock.removeClass('my-products-popup__customisation-block--visible');
            $body.removeClass('my-products-popup__body--hidden');
            $button.text('View Customisation');
        } else {
            // Show customisation, hide body
            $body.addClass('my-products-popup__body--hidden');
            $customisationBlock.addClass('my-products-popup__customisation-block--visible');
            $button.text('Hide Customisation');
        }
    });
    
    // Reset size inputs when form is reset
    $(document).on('reset', 'form[name="selected_product_options"].my-products-popup__form', function() {
        const $form = $(this);
        $form.find('.my-products-popup__size-quantity').text('0');
        $form.find('.my-products-popup__size-input').val(0);
        $form.find('.my-products-popup__size').removeClass('my-products-popup__size--active');
        $form.find('#my-products-popup__single-size').val(0);
        $form.find('#my-products-popup__qty').val(0);
        // Reset price to base price
        updatePriceDisplay($form);
    });
    
    // Initialize price display on popup open
    $(document).on('opened.zf.reveal', '.my-products-popup', function() {
        const $form = $(this).find('form[name="selected_product_options"]');
        if ($form.length) {
            updatePriceDisplay($form);
        }
    });
});
